import {withTranslation} from "react-i18next";
import "./headerButton.scss";
import {Button} from 'antd';
import {LogoutOutlined,AudioMutedOutlined} from '@ant-design/icons';

function Headerbutton(props) {
    const {t, i18n} =props;
    return (
      <>
          {!props.noSave && <Button style={{zIndex: 1000}} onClick={() => props.saveAndContinue()} className="primaryButton btn-icon-text" icon={<LogoutOutlined />}>{t("ceiba.saveexit")}</Button>}
        <h1 className={"title-game"}>{props.title}</h1>
        <Button style={{zIndex: 1000}}  className="primaryButton btn-icon-text" icon={<AudioMutedOutlined />}>{t("ceiba.sound")}</Button>
      </>
    );


}
export default withTranslation()(Headerbutton);
